import { create } from 'zustand';

import { User } from '@/entities/user';

interface UserState {
  isAuth: boolean;
  user: User | null;
  setUser: (user: User | null) => void;
  logout: () => void;
}

export const useUserStore = create<UserState>((set) => ({
  isAuth: false,
  user: null,
  setUser: (user) => set({ user, isAuth: !!user }),
  logout: () => set({ user: null, isAuth: false }),
}));
